import { Route } from 'react-router-dom';
import AllOrders from '../Pages/Orders/AllOrders';
import Layout from '../components/layout';
import OrderDetail from '../Pages/Orders/order-detail';
import ProtectedRoute from '../components/ProtectedRoute';

export const OrderRoutes = ({ menuActive, setMenuActive }) => (
  <>
    <Route path="/orders" element={
      <ProtectedRoute>
        <Layout activePage='all-orders' menuActive={menuActive} setMenuActive={setMenuActive}>
          <AllOrders />
        </Layout>
      </ProtectedRoute>
    } />
    <Route path="/order/:orderId" element={
      <ProtectedRoute>
        <Layout activePage='order-detail' menuActive={menuActive} setMenuActive={setMenuActive}>
          <OrderDetail />
        </Layout>
      </ProtectedRoute>
    } />
    <Route path="/new-order" element={
      <ProtectedRoute>
        <Layout activePage='order-detail' menuActive={menuActive} setMenuActive={setMenuActive}>
          <OrderDetail />
        </Layout>
      </ProtectedRoute>
    } />
  </>
);
